import { transparentize } from "polished";
import React from "react";
import styled, { css } from "styled-components";
import { buttonResetStyles } from "../../../utils";
import { colors } from "../../../utils/colors";
import { ArrowLeft } from "../../atoms/Icons/ArrowLeft";
import { ArrowRight } from "../../atoms/Icons/ArrowRight";

export const CircleButton = styled.button<{ reverse?: boolean }>`
    ${buttonResetStyles};
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: ${transparentize(0.9, colors.brandMid)};
    color: ${colors.brandMid};
    transition: 200ms ease all;
    text-align: center;

    &:hover {
        background-color: ${transparentize(0.8, colors.brandMid)};
    }

    ${({ reverse }) =>
        reverse &&
        css`
            border: 2px solid white;
            color: white;

            &:hover {
                background-color: white;
                color: ${colors.brandMid};
            }
        `}
`;

export const CarouselControlsWrapper = styled.div`
    display: flex;

    > *:first-child {
        margin-right: 10px;
    }
`;

export const CarouselControls = (props: {
    onLeftClick: () => void;
    onRightClick: () => void;
    reverseButtons?: boolean;
}) => {
    return (
        <CarouselControlsWrapper>
            <CircleButton reverse={props.reverseButtons} onClick={props.onLeftClick}>
                <ArrowLeft />
            </CircleButton>
            <CircleButton reverse={props.reverseButtons} onClick={props.onRightClick}>
                <ArrowRight />
            </CircleButton>
        </CarouselControlsWrapper>
    );
};
